module.exports = __webpack_public_path__ + "static/media/logo_seguro.22b3cb8a.svg";